import * as React from 'react';
import { Component } from 'react';
import { createPortal } from 'react-dom';
import propz from 'propz';
import Lazy from 'lazy.js';
import { AppUser } from 'Src/views/App/App';
import { TABS } from 'Src/consts/common';
import { SchoolEvent, SchoolEventAttendance, SchoolEventIndividualPerformance } from 'Src/models/event';
import {
  getParentEventPlayers,
  getParentEventViewTabs,
  isClubEvent,
  isHousesEvent
} from '../../../../../helpers/event/event';
import { SchoolEventGroupedTabs } from 'Src/views/GenericView/AdminView/TeamsAndEvents/Events/SchoolEventView/SchoolEventGroupedTabs';
import { LazyEventCommunications as EventCommunications } from 'Src/components/EventCommunications/LazyEventCommunications';
import { EmptyComponent } from 'Src/components/EmptyComponent/EmptyComponent';
import { ACCESS_PRESET } from 'Src/consts/album';
import { Loader } from 'Src/components/Loader/Loader';
import './SummaryTabs.scss';
import { getSchoolEventDetails } from '../../../../../helpers/service/admin/schoolEvents';
import { getSchoolEventMatchReportForParent } from 'Src/helpers/service/parent/childrenEvents';
import { getChildrenEventTasks } from 'Src/helpers/service/parent/childrenEvents';
import {
  SchoolEventPlayerSummary,
  SchoolEventTeamSummary
} from '../../../../../components/SchoolEventPlayersSummary/SchoolEventPlayersSummary';
import { getEventPlayers } from 'Src/helpers/event/event';
import { Sport } from '../../../../../models/sport';
import { DEFAULT_LIMIT, DEFAULT_SKIP } from '../../../../../consts/table';
import { getSchoolSportsPublic } from '../../../../../helpers/service/public/public';
import { Report } from '../../../../../models/report';
import BPromise from 'bluebird';
import { ChildrenEventAvailabilityReportsSummaryTab } from './ChildrenEventAvailabilityReportsSummaryTab/ChildrenEventAvailabilityReportsSummaryTab';
import { VenueView } from '../../../../../components/VenueView/VenueView';
import { SimpleModal } from '../../../../../components/SimpleModal/SimpleModal';
import { Point } from '../../../../../models/venue';
import { ChildrenEventDetailsSummaryTab } from './DetailsTab/DetailsTab';
import { ChildrenEventAttendanceSummaryTab } from './AttendanceTab/AttendanceTab';
import { ChildrenEventPlayersPositionsSummary } from './PositionsTab/PositionsTab';
import { ChildrenEventJobsSummaryTab } from './JobsTab/JobsTab';
import { ChildrenEventPerformanceSummaryTab } from './PerformanceTab/PerformanceTab';
import { ChildrenEventMatchReportSummaryTab } from './MatchReportTab/MatchReportTab';
import { ChildrenEventTeamsSummaryTab } from './TeamsTab/TeamsTab';
import { getStudentAvailabilityReports } from '../../../../../helpers/service/admin/messages';
import { ParentalConsentRequestSummaryTab } from './ParentalConsentRequestSummaryTab/ParentalConsentRequestSummaryTab';
import {
  acceptParentConsentRequest,
  getParentEventMessage,
  getParentalConsentRequest,
  rejectParentConsentRequest,
  updateParentConsentRequest
} from '../../../../../helpers/service/parent/messagesTable';
import { Video } from 'Src/models/video';
import { Photo } from 'Src/models/photo';
import { SchoolEventIndividualDiscipline } from '../../../../../models/event';
import { ChildrenEventDisciplineSummaryTab } from './DisciplineTab/DisciplineTab';
import { Child } from 'Src/models/child';
import { Button } from 'Src/components/Button/Button';
import { EventGallery } from 'Src/views/GenericView/AdminView/TeamsAndEvents/Events/SchoolEventView/Gallery/Gallery';
import { EventVideos } from 'Src/views/GenericView/AdminView/TeamsAndEvents/Events/SchoolEventView/Videos/EventVideos';
import {
  getChildrenEventPhotos,
  addChildrenEventPhoto,
  deleteChildrenEventPhoto
} from 'Src/helpers/service/parent/childrenEvents';
import { getAllEventVideos } from 'Src/helpers/service/admin/eventVideos';
import { ACCESS_PRESET_TYPE } from 'Src/types/album';
import { uploadImage } from 'Src/helpers/service/image';
import { MessageField } from 'Src/models/message';
import { FormSubmission } from 'Src/types/formSchema';
import { ParentalConsentRequestForm } from '../../ConsentRequests/ConsentRequestsInbox/ParentalConsentRequestForm/ParentalConsentRequestForm';
import { ConsentRequestDetails } from '../../ConsentRequests/ConsentRequestDetails/ConsentRequestDetails';
import { EventInvitationMessage } from 'Src/models/message';
import { getChildrenAwardsCurrent } from 'Src/helpers/service/parent/awards';
import { hasVisibleEventDetails } from 'Src/components/EventDetailsSummary/EventDetailsSummary';
import { SchoolEventAwardsSummary } from 'Src/components/SchoolEventAwardsSummary/SchoolEventAwardsSummary';

interface Props {
  user: AppUser;
  eventInitial: SchoolEvent;
  eventName: string;
  childrenInEvent: Child[];
  onConsentChange?: () => void;
  onEditAvailability?: (report: Report) => void;
  initialTab?: string;
  initialConversationId?: string;
}

const countPendingAvailability = (reports: Report[]): number => {
  const latestByStudent = new Map<string, Report>();
  reports.forEach((report, index) => {
    const key = String(
      propz.get(report, ['playerDetails', 'userId'], '') ||
        propz.get(report, ['playerDetails', 'permissionId'], '') ||
        propz.get(report, ['playerDetailsData', 'id'], '') ||
        index
    );
    const current = latestByStudent.get(key);
    if (!current || new Date(report.createdAt).getTime() > new Date(current.createdAt).getTime()) latestByStudent.set(key, report);
  });
  return Array.from(latestByStudent.values()).filter(report => {
    if (typeof report.isTakePart === 'boolean') return false;
    const cutoff = (report as any).availabilityDeadline || propz.get(report, ['eventData', 'startTime'], '');
    return !cutoff || new Date(cutoff).getTime() > Date.now();
  }).length;
};

interface State {
  currentTabIndex: number;
  eventTaskIndex: number;
  eventDetails: any;
  isLoading: boolean;
  isErrorModalOpen: boolean;
  errorMessage: string;
  eventTasks: any[];
  individualPerformance: SchoolEventIndividualPerformance[];
  individualDiscipline: SchoolEventIndividualDiscipline[];
  attendancePlayers: SchoolEventAttendance[];
  event: SchoolEvent;
  matchReport: string;
  sports: Sport[];
  playersForSummary: SchoolEventPlayerSummary[];
  teamsForSummary: SchoolEventTeamSummary[];
  activeTeamIndex: number;
  reports: Report[];
  consents: Report[];
  isVenueFormOpen: boolean;
  point: Point;
  childIdList: string[];
  photos: Photo[];
  videos: Video[];
  isUpdateAccessPreset: boolean;
  isConsentModalOpen: boolean;
  consentModalMode?: 'edit' | 'accept';
  selectedConsent?: Report;
  isConsentDetailsOpen: boolean;
  isConsentDetailsLoading: boolean;
  selectedConsentForDetails?: { consentRequest: EventInvitationMessage; childEvent: SchoolEvent };
  isCancelConsentConfirmationOpen: boolean;
  consentPendingCancellation?: Report;
  consentDeclineReason: string;
  awards: any[];
}

export class ChildrenSummaryTabs extends Component<Props, State> {
  private loadRequestId = 0;
  private consentDetailsRequestId = 0;
  private initialTabApplied = false;
  photoFileInputRef: any;

  constructor(props: Props) {
    super(props);

    this.state = {
      currentTabIndex: 0,
      eventTaskIndex: 0,
      eventDetails: undefined,
      isLoading: true,
      isErrorModalOpen: false,
      errorMessage: '',
      eventTasks: [],
      individualPerformance: [],
      individualDiscipline: [],
      attendancePlayers: [],
      event: props.eventInitial,
      matchReport: '',
      sports: [],
      playersForSummary: [],
      teamsForSummary: [],
      activeTeamIndex: 0,
      reports: [],
      consents: [],
      isVenueFormOpen: false,
      point: undefined,
      childIdList: [],
      photos: [],
      videos: [],
      isUpdateAccessPreset: false,
      isConsentModalOpen: false,
      consentModalMode: undefined,
      selectedConsent: undefined,
      isConsentDetailsOpen: false,
      isConsentDetailsLoading: false,
      selectedConsentForDetails: undefined,
      isCancelConsentConfirmationOpen: false,
      consentPendingCancellation: undefined,
      consentDeclineReason: '',
      awards: []
    };
  }

  componentDidMount() {
    this.setState({
      isLoading: true
    });
    this.setItems();
  }

  componentWillUnmount() {
    this.loadRequestId += 1;
  }

  private showRequestError = (error: any, fallbackMessage: string) => {
    const errorText =
      propz.get(error, ['response', 'data', 'details', 'text'], '') ||
      propz.get(error, ['response', 'data', 'message'], '') ||
      propz.get(error, ['message'], '') ||
      fallbackMessage;
    this.setState({ isLoading: false, errorMessage: errorText, isErrorModalOpen: true });
  };

  setItems(): Promise<void> {
    const requestId = ++this.loadRequestId;
    const { user, childrenInEvent } = this.props;
    const { event, currentTabIndex } = this.state;
    const currentTab = this.getTabs()[currentTabIndex];
    const tabToRestore = !this.initialTabApplied && this.props.initialTab ? this.props.initialTab : currentTab;

    this.setState({
      isLoading: true
    });
    const getAvailabilityReportsPromise = getStudentAvailabilityReports(user, event.id);
    const getParentalConsentPromise = getParentalConsentRequest(user, event.id);
    const detailsPromise = getSchoolEventDetails(user, event.id);
    const tasksPromise = this.getEventTasks();
    const eventChildIds = childrenInEvent.map(child => child.id);
    const awardsPromise = eventChildIds.length
      ? getChildrenAwardsCurrent(user, {
          limit: 100,
          order: 'awardedAt DESC',
          where: { eventId: event.id, childIdList: eventChildIds }
        })
      : BPromise.resolve([]);
    const promises = [
      getAvailabilityReportsPromise,
      getParentalConsentPromise,
      detailsPromise,
      tasksPromise,
      awardsPromise
    ];
    return BPromise.all(promises)
      .then(([reports, consents, eventDetails, eventTasks, awards]) => {
        if (requestId !== this.loadRequestId) return;
        const childIdList = eventChildIds;
        this.setState(
          {
            reports,
            consents,
            childIdList,
            eventDetails,
            eventTasks,
            awards,
            isLoading: false
          },
          () => {
            this.initialTabApplied = true;
            const restoredIndex = tabToRestore ? this.getTabs().indexOf(tabToRestore) : -1;
            if (restoredIndex >= 0 && restoredIndex !== this.state.currentTabIndex) {
              this.setState({ currentTabIndex: restoredIndex });
            }
          }
        );
      })
      .catch(error => {
        if (requestId !== this.loadRequestId) return;
        console.error(error);
        this.showRequestError(error, 'Event information could not be loaded. Please try again.');
      });
  }

  getEventTasks = () => {
    const { user, childrenInEvent } = this.props;
    const { event } = this.state;
    const { id } = event;

    const childrenIds: string[] = childrenInEvent.map(child => child.id);

    const uniqueSchoolIds: string[] = (Lazy(childrenInEvent) as any)
      .map(child => child.schoolId)
      .uniq()
      .toArray();

    const getChildrenEventTasksPromises = [];

    uniqueSchoolIds.forEach(schoolId => {
      getChildrenEventTasksPromises.push(getChildrenEventTasks(user, id, schoolId));
    });

    return BPromise.all(getChildrenEventTasksPromises).then(childrenEventTasks => {
      let allTasks = [];

      childrenEventTasks.forEach(item => {
        allTasks = [...allTasks, ...item];
      });

      const result = allTasks.filter(task => {
        const { assignees } = task;

        return assignees.find(item => {
          const { userId } = item;

          return childrenIds.some(childId => String(childId) === String(userId));
        });
      });

      return result;
    });
  };

  getTabs = (): string[] => {
    const { event, reports, consents, eventDetails, eventTasks, awards } = this.state;
    const tabs = getParentEventViewTabs(
      event,
      reports.length > 0,
      consents.length > 0,
      hasVisibleEventDetails(event, eventDetails),
      eventTasks.length > 0,
      awards.length > 0
    ).filter(tab => tab !== TABS.FEED);
    if (!tabs.includes(TABS.COMMUNICATIONS)) tabs.push(TABS.COMMUNICATIONS);
    if (
      (!this.props.user.activeSchool || (this.props.user.activeSchool as any).eventCommunicationsAvailable !== false) &&
      !tabs.includes(TABS.COMMUNICATION_NOTIFICATIONS)
    ) {
      tabs.push(TABS.COMMUNICATION_NOTIFICATIONS);
    }
    return tabs;
  };

  onTabClick = (e, index: number) => {
    e.preventDefault();

    const { user, childrenInEvent } = this.props;
    const { event } = this.state;
    const { id, results } = event;
    const tabs = this.getTabs();
    const currentTab = tabs[index];

    const childSchoolId = propz.get(childrenInEvent[0], ['schoolId'], '');

    const { individualPerformance, individualDiscipline, attendance } = results;
    const attendancePlayers = attendance.map(player => ({ ...player }));

    switch (currentTab) {
      case TABS.DETAILS:
        this.setState({ currentTabIndex: index });
        break;
      case TABS.POSITIONS:
        const playersForSummary = this.getPlayersForSummary(event);
        const teamsForSummary = this.getTeamsForSummary();
        if (this.state.sports.length === 0) {
          const filter = { limit: DEFAULT_LIMIT, order: 'name ASC', skip: DEFAULT_SKIP };
          this.setState({ isLoading: true });
          getSchoolSportsPublic(childSchoolId || user.activeSchoolId, filter)
            .then(sports => this.setState({
              currentTabIndex: index,
              playersForSummary,
              teamsForSummary,
              sports,
              isLoading: false
            }))
            .catch(error => this.showRequestError(error, 'Sports could not be loaded. Please try again.'));
        } else {
          this.setState({ currentTabIndex: index, playersForSummary, teamsForSummary });
        }
        break;
      case TABS.ATTENDANCE:
        this.setState({
          currentTabIndex: index,
          attendancePlayers
        });
        break;
      case TABS.JOBS:
        this.setState({ currentTabIndex: index });
        break;
      case isClubEvent(event) ? TABS.PROGRESS : TABS.PERFORMANCE:
        this.setState({
          currentTabIndex: index,
          individualPerformance: individualPerformance
        });
        break;
      case TABS.DISCIPLINE:
        this.setState({
          currentTabIndex: index,
          individualDiscipline: individualDiscipline
        });
        break;
      case isClubEvent(event) ? TABS.LEADER_COACH_NOTES : TABS.MATCH_REPORT:
        this.setState({
          isLoading: true
        });
        getSchoolEventMatchReportForParent(user, childSchoolId, id)
          .then(matchReport => {
            const content = propz.get(matchReport, ['content'], '');
            this.setState({
              currentTabIndex: index,
              matchReport: content,
              isLoading: false
            });
          })
          .catch(error => {
            this.showRequestError(error, 'The match report could not be loaded. Please try again.');
          });
        break;
      case TABS.PARENTAL_CONSENT:
        this.setState({ currentTabIndex: index });
        break;

      case TABS.GALLERY: {
        this.setState({
          isLoading: true
        });
        const promises = [getChildrenEventPhotos(user, id), getAllEventVideos(user, id)];
        BPromise.all(promises)
          .then(([photos, videos]) => {
            this.setState({
              isLoading: false,
              currentTabIndex: index,
              photos,
              videos
            });
          })
          .catch(error => {
            this.showRequestError(error, 'Event media could not be loaded. Please try again.');
          });
        break;
      }
      default:
        this.setState({
          currentTabIndex: index
        });
    }
  };

  onAccessPresetPhotoClick = (photoId: string, accessPreset: ACCESS_PRESET_TYPE) => {
    return;
  };

  onAccessPresetVideoClick = (videoId: string, accessPreset: ACCESS_PRESET_TYPE) => {
    return;
  };

  onViewMapClick = (point): void => {
    this.setState({
      point: point,
      isVenueFormOpen: true
    });
  };

  private isWithinWindow = (consent: Report): boolean => {
    const startStr = propz.get(consent, ['eventData', 'startTime'], '');
    const start = startStr ? new Date(startStr) : undefined;
    const deadlineStr = propz.get(consent, ['deadlineForAnswers'], '');
    const hasDeadline = !!deadlineStr;
    const deadline = hasDeadline ? new Date(deadlineStr) : undefined;
    const now = new Date();

    if (hasDeadline && deadline) return now < deadline;
    if (start) return now < start;
    return true;
  };

  private openConsentEditModal = (consent: Report) => {
    this.setState({ isConsentModalOpen: true, consentModalMode: 'edit', selectedConsent: consent });
  };

  private openConsentAcceptModal = (consent: Report) => {
    this.setState({ isConsentModalOpen: true, consentModalMode: 'accept', selectedConsent: consent });
  };

  private closeConsentModal = () => {
    this.setState({ isConsentModalOpen: false, consentModalMode: undefined, selectedConsent: undefined });
  };

  private openConsentDetails = async (consent: Report) => {
    const { event } = this.state;
    const requestId = ++this.consentDetailsRequestId;
    const initialItem = { consentRequest: (consent as unknown) as EventInvitationMessage, childEvent: event };

    this.setState({
      isConsentDetailsOpen: true,
      isConsentDetailsLoading: true,
      selectedConsentForDetails: initialItem
    });

    try {
      const detailedConsent = await getParentEventMessage(this.props.user, consent.id);
      if (requestId !== this.consentDetailsRequestId) return;

      this.setState({
        isConsentDetailsLoading: false,
        selectedConsentForDetails: {
          consentRequest: detailedConsent as EventInvitationMessage,
          childEvent: event
        }
      });
    } catch (error) {
      if (requestId !== this.consentDetailsRequestId) return;
      // The compact event response is still useful if the dedicated details
      // request fails, so keep the drawer open instead of replacing it with a
      // page-level error.
      this.setState({ isConsentDetailsLoading: false });
    }
  };

  private closeConsentDetails = () => {
    this.consentDetailsRequestId += 1;
    this.setState({
      isConsentDetailsOpen: false,
      isConsentDetailsLoading: false,
      selectedConsentForDetails: undefined
    });
  };

  private onUpdateConsentFields = async (fields: MessageField[], submission?: FormSubmission) => {
    const { user } = this.props;
    const { selectedConsent } = this.state;
    if (!selectedConsent) return;

    const id = selectedConsent.id;
    this.setState({ isLoading: true });

    try {
      await updateParentConsentRequest(user, id, { fields, ...(submission || {}) });
      await this.setItems();
      if (this.props.onConsentChange) this.props.onConsentChange();
      this.setState({ isLoading: false });
      this.closeConsentModal();
    } catch (e) {
      this.showRequestError(e, 'The consent response could not be updated. Please try again.');
    }
  };

  private onAcceptConsentFromModal = async (fields: MessageField[], submission?: FormSubmission) => {
    const { user } = this.props;
    const { selectedConsent } = this.state;
    if (!selectedConsent) return;

    const id = selectedConsent.id;
    this.setState({ isLoading: true });

    try {
      await acceptParentConsentRequest(user, id, { fields, ...(submission || {}) });
      await this.setItems();
      if (this.props.onConsentChange) this.props.onConsentChange();
      this.setState({ isLoading: false });
      this.closeConsentModal();
    } catch (e) {
      this.showRequestError(e, 'Consent could not be accepted. Please try again.');
    }
  };

  private onRejectConsent = async (consent: Report, declineReason = this.state.consentDeclineReason) => {
    const { user } = this.props;
    this.setState({ isLoading: true });
    try {
      await rejectParentConsentRequest(user, consent.id, declineReason);
      await this.setItems();
      if (this.props.onConsentChange) this.props.onConsentChange();
      this.setState({ isLoading: false });
    } catch (e) {
      this.showRequestError(e, 'Consent could not be declined. Please try again.');
    }
  };

  private renderConsentModal = () => {
    const { isConsentModalOpen, consentModalMode, selectedConsent } = this.state;
    if (!isConsentModalOpen || !selectedConsent) return null;

    const isAcceptMode = consentModalMode === 'accept';
    const title = isAcceptMode ? 'Accept consent' : 'Edit response';
    const onAccept = isAcceptMode ? this.onAcceptConsentFromModal : this.onUpdateConsentFields;

    const statusUpper = String((selectedConsent as any)?.invitationStatus || '').toUpperCase();
    const wasRejected = statusUpper === 'REJECTED';

    const messageForForm =
      isAcceptMode && wasRejected
        ? {
            ...(selectedConsent as any),
            fields: ((selectedConsent as any).fields || []).map(f => ({ ...f, value: '' })),
            formAnswers: []
          }
        : (selectedConsent as any);

    return (
      <SimpleModal
        isOpen={isConsentModalOpen}
        onCloseClick={this.closeConsentModal}
        showFooter={false}
        customClass="AcceptModal"
        title={title}
        guardUnsavedChanges
        unsavedChangesMessage="You have unsaved consent answers. If you close now, those changes will be lost."
      >
        <ParentalConsentRequestForm
          user={this.props.user}
          message={messageForForm}
          onCloseClick={this.closeConsentModal}
          onAcceptClick={onAccept}
        />
      </SimpleModal>
    );
  };

  private renderConsentDetailsModal = () => {
    const { isConsentDetailsOpen, isConsentDetailsLoading, selectedConsentForDetails } = this.state;
    if (!isConsentDetailsOpen || !selectedConsentForDetails) return null;

    const drawer = (
      <SimpleModal
        isOpen={isConsentDetailsOpen}
        onCloseClick={this.closeConsentDetails}
        showFooter={false}
        customClass="consentDetailsDrawer"
        title="Consent request details"
        side="right"
      >
        {isConsentDetailsLoading ? (
          <div className="consentDetailsDrawer__loading">
            <Loader />
            <span>Loading questions and answers…</span>
          </div>
        ) : (
          <ConsentRequestDetails message={selectedConsentForDetails} childIdList={this.state.childIdList} />
        )}
      </SimpleModal>
    );

    return typeof document === 'undefined' ? drawer : createPortal(drawer, document.body);
  };

  private requestCancelConsent = (consent: Report) => {
    this.setState({
      isCancelConsentConfirmationOpen: true,
      consentPendingCancellation: consent,
      consentDeclineReason: ''
    });
  };

  private closeCancelConsentConfirmation = () => {
    this.setState({
      isCancelConsentConfirmationOpen: false,
      consentPendingCancellation: undefined,
      consentDeclineReason: ''
    });
  };

  private confirmCancelConsent = async () => {
    const { consentPendingCancellation } = this.state;
    if (!consentPendingCancellation) return;
    const declineReason = this.state.consentDeclineReason;
    this.closeCancelConsentConfirmation();
    await this.onRejectConsent(consentPendingCancellation, declineReason);
  };

  private renderCancelConsentConfirmation = () => {
    const { isCancelConsentConfirmationOpen, consentPendingCancellation } = this.state;
    if (!isCancelConsentConfirmationOpen || !consentPendingCancellation) return null;

    const studentName = [
      propz.get(consentPendingCancellation, ['playerDetailsData', 'firstName'], ''),
      propz.get(consentPendingCancellation, ['playerDetailsData', 'lastName'], '')
    ].filter(Boolean).join(' ');
	const isPending = String(consentPendingCancellation.invitationStatus || '').toUpperCase() === 'NOT_READY';

    const modal = (
      <SimpleModal
        isOpen={isCancelConsentConfirmationOpen}
		title={isPending ? 'Confirm decline' : 'Cancel response?'}
        onCloseClick={this.closeCancelConsentConfirmation}
        onBackdropClick={this.closeCancelConsentConfirmation}
        showFooter={false}
        isBodyBold={false}
        customClass="cancelConsentConfirmation"
        dialogStyle={{ maxWidth: 470 }}
        zIndex={2060}
      >
        <div className="cancelConsentConfirmation__content">
          <div className="cancelConsentConfirmation__notice">
            <span aria-hidden="true">!</span>
            <div>
			  <strong>{isPending ? 'Decline this consent request?' : 'The current consent response will be cancelled.'}</strong>
              <p>
				{isPending
				  ? `The school will be notified that ${studentName || 'the student'} is not able to take part.`
				  : `${studentName ? `${studentName}'s` : 'This'} response will change to declined. You can submit a new response while the request is still open.`}
              </p>
            </div>
          </div>
		  <div className="cancelConsentConfirmation__event">
			<span>Event</span>
			<strong>{this.props.eventName}</strong>
		  </div>
		  <label className="cancelConsentConfirmation__reason"><span>Reason <small>Optional · shared with the school</small></span><textarea maxLength={2000} value={this.state.consentDeclineReason} placeholder="For example: family commitment that day" onChange={event=>this.setState({consentDeclineReason:event.target.value})}/></label>
          <div className="cancelConsentConfirmation__actions">
			<button type="button" onClick={this.closeCancelConsentConfirmation}>{isPending ? 'Go back' : 'Keep response'}</button>
			<button type="button" className="is-danger" onClick={this.confirmCancelConsent}>{isPending ? 'Decline request' : 'Cancel response'}</button>
          </div>
        </div>
      </SimpleModal>
    );

    return typeof document === 'undefined' ? modal : createPortal(modal, document.body);
  };

  getContentTabs(): React.ReactNode {
    const { user, eventName, childrenInEvent } = this.props;
    const { event, reports, consents, awards } = this.state;
    const {
      currentTabIndex,
      eventDetails,
      eventTasks,
      individualPerformance,
      individualDiscipline,
      matchReport,
      sports,
      activeTeamIndex,
      playersForSummary,
      teamsForSummary,
      childIdList,
      photos,
      videos,
      isUpdateAccessPreset
    } = this.state;
    const childrenInEventsIds: string[] = childrenInEvent.map(child => child.id);

    const tabs = this.getTabs();
    const currentTab = tabs[currentTabIndex];

    const { results } = event;

    const { attendance } = results;
    const attendancePlayers = attendance.map(player => ({ ...player }));

    const childrenSchoolsIds = (Lazy(childrenInEvent) as any)
      .map(child => child.schoolId)
      .uniq()
      .toArray();

    const allTeamPlayers = getParentEventPlayers(event, childIdList);

    let allPlayers = [];

    childrenSchoolsIds.forEach(schoolId => {
      const players = getEventPlayers(event, schoolId);
      allPlayers = [...allPlayers, ...players];
    });

    const currentSport = sports.find(sport => sport.id === event.sportId);

    switch (currentTab) {
      case TABS.COMMUNICATIONS:
        return <EventCommunications user={user} eventId={event.id} panel="CHATS" initialConversationId={this.props.initialConversationId} subjects={childrenInEvent.map(child => ({permissionId: child.permissionId, label: `${child.firstName} ${child.lastName}`}))} />;
      case TABS.COMMUNICATION_NOTIFICATIONS:
        return <EventCommunications user={user} eventId={event.id} panel="SETTINGS" subjects={childrenInEvent.map(child => ({permissionId: child.permissionId, label: `${child.firstName} ${child.lastName}`}))} />;
      case TABS.DETAILS:
        return <ChildrenEventDetailsSummaryTab schoolEvent={event} eventsDetails={eventDetails} />;
      case TABS.POSITIONS:
        return (
          <ChildrenEventPlayersPositionsSummary
            schoolEvent={event}
            sport={currentSport}
            players={playersForSummary}
            teams={teamsForSummary}
            activeTeamIndex={activeTeamIndex}
            onChangeTeam={this.onChangeTeam}
          />
        );
      case TABS.ATTENDANCE:
        return (
          <ChildrenEventAttendanceSummaryTab
            schoolEvent={event}
            allTeamPlayers={allTeamPlayers}
            attendancePlayers={attendancePlayers}
          />
        );
      case TABS.JOBS:
        return <ChildrenEventJobsSummaryTab eventTasks={eventTasks} childrenInEventsIds={childrenInEventsIds} />;
      case TABS.AWARDS: {
        const awardTypesById = awards.reduce((result, award) => {
          if (award.awardType && award.awardType.id) result[award.awardType.id] = award.awardType;
          return result;
        }, {});
        const players = childrenInEvent.map(child => ({
          userId: child.id,
          permissionId: child.permissionId,
          firstName: child.firstName,
          lastName: child.lastName
        }));
        return <SchoolEventAwardsSummary awards={awards} awardTypesById={awardTypesById} players={players} />;
      }
      case isClubEvent(event) ? TABS.PROGRESS : TABS.PERFORMANCE:
        return (
          <ChildrenEventPerformanceSummaryTab
            schoolEvent={event}
            allTeamPlayers={allTeamPlayers}
            individualPerformance={individualPerformance}
          />
        );
      case TABS.DISCIPLINE:
        return (
          <ChildrenEventDisciplineSummaryTab
            schoolEvent={event}
            allTeamPlayers={allPlayers}
            individualDiscipline={individualDiscipline}
          />
        );
      case TABS.PARTICIPANTS:
      case TABS.PLAYERS:
        return <ChildrenEventTeamsSummaryTab user={user} eventInitial={event} childrenInEvent={childrenInEvent} availabilityReports={reports} />;
      case isClubEvent(event) ? TABS.LEADER_COACH_NOTES : TABS.MATCH_REPORT:
        return <ChildrenEventMatchReportSummaryTab schoolEvent={event} matchReport={matchReport} />;
      case TABS.AVAILABILITY_REPORTS:
        return (
          <ChildrenEventAvailabilityReportsSummaryTab
            reports={reports}
            user={user}
            onViewMapClick={this.onViewMapClick}
            onEditReport={this.props.onEditAvailability}
          />
        );
      case TABS.PARENTAL_CONSENT:
        return (
          <ParentalConsentRequestSummaryTab
            consents={consents}
            user={user}
            event={event}
            eventName={eventName}
            childIdList={childIdList}
            onViewMapClick={this.onViewMapClick}
            onOpenEditModal={this.openConsentEditModal}
            onOpenAcceptModal={this.openConsentAcceptModal}
			onReject={this.requestCancelConsent}
            onRequestCancel={this.requestCancelConsent}
            isWithinWindow={this.isWithinWindow}
            onOpenDetails={this.openConsentDetails}
          />
        );

      case TABS.GALLERY:
        return (
          <>
            <EventGallery
              onDeletePhotoClick={this.onDeletePhotoClick}
              user={user}
              eventInitial={event}
              photos={photos}
              onAccessPresetClick={this.onAccessPresetPhotoClick}
              isUpdateAccessPreset={isUpdateAccessPreset}
            />
            <EventVideos
              user={user}
              eventInitial={event}
              videos={videos}
              onAccessPresetClick={this.onAccessPresetVideoClick}
              isUpdateAccessPreset={isUpdateAccessPreset}
            />
          </>
        );
      default:
        return <EmptyComponent />;
    }
  }

  getPlayersForSummary(event: SchoolEvent): SchoolEventPlayerSummary[] {
    const { childIdList } = this.state;

    const schoolPlayers = getParentEventPlayers(event, childIdList);

    return schoolPlayers.map(schoolPlayer => {
      const { userId, permissionId, firstName, lastName, form, id, teamId } = schoolPlayer;
      const isFormExist = typeof form !== 'undefined';
      const formName = isFormExist ? form.name : '';

      const playerFromEvent = event.players.find(
        player => player.userId === userId && player.permissionId === permissionId
      );

      const positionId = typeof playerFromEvent !== 'undefined' ? playerFromEvent.positionId : '';
      const isCaptain = typeof playerFromEvent !== 'undefined' ? playerFromEvent.isCaptain : false;
      const isSub = typeof playerFromEvent !== 'undefined' ? playerFromEvent.sub : false;

      return {
        name: `${firstName} ${lastName}`,
        playerId: id,
        form: formName,
        positionId: positionId,
        isCaptain: isCaptain,
        isSub: isSub,
        teamId: teamId
      };
    });
  }

  getTeamsForSummary(): SchoolEventTeamSummary[] {
    const { user } = this.props;
    const { activeSchoolId } = user;
    const { event } = this.state;

    return event.teamsData
      .filter(team => team.schoolId === activeSchoolId)
      .map(team => ({
        teamName: team.name,
        teamId: team.id,
        houseName: isHousesEvent(event) ? team.house.name : undefined
      }));
  }

  onChangeTeam = event => {
    const { teamsForSummary } = this.state;
    const teamId = event.target.value;
    const currentTeamIndex = teamsForSummary.findIndex(team => team.teamId === teamId);

    this.setState({
      activeTeamIndex: currentTeamIndex
    });
  };

  onCancelButtonClick = (): void => {
    this.setState({
      isVenueFormOpen: false
    });
  };

  onCloseErrorClick = () => {
    this.setState({
      isErrorModalOpen: false,
      errorMessage: ''
    });
  };

  renderVenueModal() {
    const { point } = this.state;
    return (
      <SimpleModal isOpen={this.state.isVenueFormOpen} title={'Venue'}>
        <VenueView point={point} onOkClick={this.onCancelButtonClick} />
      </SimpleModal>
    );
  }

  renderSendingError(): React.ReactNode {
    const { errorMessage, isErrorModalOpen } = this.state;

    return (
      <SimpleModal
        isOpen={isErrorModalOpen}
        title={'Error'}
        buttonCancelText={'Ok'}
        onCloseClick={this.onCloseErrorClick}
      >
        <pre>{errorMessage}</pre>
      </SimpleModal>
    );
  }

  onPhotoFileChange = event => {
    const { user, eventInitial } = this.props;
    const { id } = eventInitial;
    const image = event.target.files[0];
    const photoAccessPreset = ACCESS_PRESET.PRIVATE;

    this.setState({
      isLoading: true
    });

    uploadImage(user, image)
      .then(response => {
        const picUrl = `${window.apiImg}/images/${response.key}`;
        const data = {
          picUrl: picUrl,
          originalFileName: image.name,
          accessPreset: photoAccessPreset
        };
        return addChildrenEventPhoto(user, id, data);
      })
      .then(res => getChildrenEventPhotos(user, id))
      .then(photos => {
        this.setState({
          isLoading: false,
          photos: photos
        });
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          isErrorModalOpen: true,
          errorMessage:
            propz.get(error, ['response', 'data', 'details', 'text']) ||
            'The photo could not be uploaded. Please try again.'
        });
      });
  };

  renderPhotoFileInput() {
    return (
      <input
        className="eAddPhotoButton_fileInput"
        type="file"
        accept="image/*"
        aria-label="Choose a photo"
        onChange={this.onPhotoFileChange}
        ref={input => (this.photoFileInputRef = input)}
      />
    );
  }
  onDeletePhotoClick = (photoId: string) => {
    const { user } = this.props;
    const { event } = this.state;
    const { id } = event;
    this.setState({ isLoading: true });
    deleteChildrenEventPhoto(user, id, photoId)
      .then(() => getChildrenEventPhotos(user, id))
      .then(photos => this.setState({ isLoading: false, photos }))
      .catch(error =>
        this.setState({
          isLoading: false,
          isErrorModalOpen: true,
          errorMessage:
            propz.get(error, ['response', 'data', 'details', 'text']) ||
            'The photo could not be deleted. Please try again.'
        })
      );
  };

  onAddPhotoClick = eventDescriptor => {
    let event;
    //This is true only for IE,firefox
    //Dirty hack from https://codeproject.com/Tips/893254/JavaScript-Triggering-Event-Manually-in-Internet-E
    //However, MDN recommend use very similar polyfill https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/MouseEvent#Polyfill
    if (document.createEvent) {
      // To create a mouse event , first we need to create an event and then initialize it.
      event = document.createEvent('MouseEvent');
      event.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
    } else {
      event = new MouseEvent('click');
    }
    this.photoFileInputRef.dispatchEvent(event);
    eventDescriptor.stopPropagation();
  };

  render() {
    const { user } = this.props;
    const { currentTabIndex, isLoading, event, reports, consents, isVenueFormOpen, isErrorModalOpen } = this.state;
    const { activeSchool } = user;
    const { settings } = activeSchool;
    const { photosEnabled } = settings;
    const tabs = this.getTabs();
    const contentTabs = this.getContentTabs();
    const currentTab = tabs[currentTabIndex];

    const isShowAddPhotoButton = photosEnabled && currentTab === TABS.GALLERY;

    if (isLoading) {
      return <Loader />;
    }

    const classes = isVenueFormOpen || isErrorModalOpen ? 'mt-3 modal-open' : 'mt-3';
    return (
      <div className={classes}>
        {this.renderVenueModal()}
        {this.renderSendingError()}
        {this.renderPhotoFileInput()}
        {this.renderConsentModal()}
        {this.renderConsentDetailsModal()}
        {this.renderCancelConsentConfirmation()}
        <SchoolEventGroupedTabs
          portalRole="parent"
          communicationsUser={user}
          communicationsEventId={event.id}
          groupBadges={{
            'Consent & Availability':
              countPendingAvailability(reports) +
              consents.filter(consent => String(consent.invitationStatus || '').toUpperCase() === 'NOT_READY' && this.isWithinWindow(consent)).length
          }}
          onTabClick={this.onTabClick}
          tabs={tabs}
          currentTabIndex={currentTabIndex}
        >
          {isShowAddPhotoButton && (
            <Button
              onClick={this.onAddPhotoClick}
              text={'Add photo'}
              customClass={'sit-btn sit-btn--primary sit-btn--sm'}
            />
          )}
          {contentTabs}
        </SchoolEventGroupedTabs>
      </div>
    );
  }
}
